import React, { useState } from "react";
import { FaViber, FaWhatsapp } from "react-icons/fa";
import { IoCall } from "react-icons/io5";
import { motion, AnimatePresence } from "framer-motion";

const FloatingSocialMenu = () => {
  const [open, setOpen] = useState(false);

  const viberUrl = "viber://chat?number=%2B306941419012";
  const whatsappUrl = "https://wa.me/+306941419012";

  const buttonVariants = {
    animate: {
      y: [0, -6, 0],
      transition: {
        y: {
          repeat: Infinity,
          duration: 2,
          ease: "easeInOut"
        }
      }
    },
    tap: {
      scale: 0.9,
      rotate: [0, 15, -15, 0],
      transition: {
        duration: 0.5
      }
    }
  };

  const containerVariants = {
    hidden: { 
      opacity: 0,
      y: -20 // Start above final position for exit
    },
    show: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.3,
        staggerChildren: 0.1
      }
    },
    exit: {
      opacity: 0,
      y: -20, // Slide up when exiting
      transition: {
        duration: 0.2
      }
    }
  };

  const itemVariants = {
    hidden: { 
      opacity: 0, 
      y: -10,
      scale: 0.8
    },
    show: { 
      opacity: 1, 
      y: 0,
      scale: 1,
      transition: { 
        type: "spring",
        stiffness: 300,
        damping: 10
      }
    }
  };

  // Social icon hover effects
  const socialIconVariants = {
    hover: {
      scale: 1.1,
      boxShadow: "0px 0px 8px rgba(255,255,255,0.5)",
      transition: {
        type: "spring",
        stiffness: 400,
        damping: 10
      }
    }
  };

  return (
    <div className="fixed bottom-8 left-8 z-50">
      <div className="relative">
        <motion.button
          className="bg-blue-600 border-2 border-blue-400 text-white p-4 rounded-full shadow-lg hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 transition-colors duration-300"
          onClick={() => setOpen(!open)}
          variants={buttonVariants}
          animate="animate"
          whileTap="tap"
          initial="animate"
        >
          <motion.div
            animate={{ rotate: open ? 360 : 0 }}
            transition={{ duration: 0.5 }}
          >
            <IoCall className="text-center items-center text-4xl" />
          </motion.div>
        </motion.button>

        <AnimatePresence mode="wait">
          {open && (
            <motion.div 
              className="flex flex-col gap-4 absolute bottom-24 left-0"
              initial="hidden"
              animate="show"
              exit="exit" 
              variants={containerVariants}
            >
              <motion.a
                href={viberUrl}
                className="bg-purple-600 text-white self-center p-3 rounded-full shadow-lg"
                variants={itemVariants}
                whileHover="hover"
              >
                <motion.div variants={socialIconVariants}>
                  <FaViber className="text-center items-center text-4xl" />
                </motion.div>
              </motion.a>
              
              <motion.a
                href={whatsappUrl}
                className="bg-green-500 text-white self-center p-3 rounded-full shadow-lg"
                variants={itemVariants}
                whileHover="hover"
              >
                <motion.div variants={socialIconVariants}>
                  <FaWhatsapp className="text-center items-center text-4xl" />
                </motion.div>
              </motion.a>
            </motion.div>
          )}
        </AnimatePresence>
      </div>
    </div>
  );
};

export default FloatingSocialMenu;
